import {
  Component,
  DestroyRef,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import { MatButton } from '@angular/material/button';
import { Router, RouterLink } from '@angular/router';
import { AsyncPipe, NgClass } from '@angular/common';
import { Notification } from '@app/pages/notifications/models/notification.model';
import { NotificationsStore } from '@app/pages/notifications/store/notifications.store';
import { Observable } from 'rxjs';

import { NotificationCardComponent } from '@app/pages/notifications/components/notification-card/notification-card.component';
import { TranslatePipe } from '@ngx-translate/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  CdkFixedSizeVirtualScroll,
  CdkVirtualForOf,
  CdkVirtualScrollViewport,
  ScrollingModule
} from '@angular/cdk/scrolling';

@Component({
  selector: 'app-notification-panel',
  imports: [
    MatButton,
    RouterLink,
    NgClass,
    AsyncPipe,
    NotificationCardComponent,
    TranslatePipe,
    CdkFixedSizeVirtualScroll,
    CdkVirtualScrollViewport,
    CdkVirtualForOf,
    ScrollingModule
  ],
  templateUrl: './notification-panel.component.html',
  styleUrl: './notification-panel.component.scss'
})
export class NotificationPanelComponent implements OnDestroy, OnInit {
  @Output() closePanel = new EventEmitter();
  public readonly notificationCount$: Observable<number> =
    this.notificationsStore.notificationCountUnread$;

  public readonly userIdForNotifications$ =
    this.notificationsStore.userIdForNotifications$;

  private observer!: IntersectionObserver;
  private timers: { [key: string]: any } = {};

  public isLoading = false;
  public isActiveFilterType = true;
  public notificationsLists: Notification[] = [];

  constructor(
    private notificationsStore: NotificationsStore,
    private destroyRef: DestroyRef,
    private router: Router
  ) {}

  ngOnInit() {
    this.streamToNotificationsLists();
  }

  private streamToNotificationsLists(): void {
    this.notificationsStore.notificationsFiltersLists$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(notificationsLists => {
        this.notificationsLists = notificationsLists;
      });
  }

  public deleteNotification(notificationId: string): void {
    this.notificationsStore.deleteNotification(notificationId);
  }

  public filterBy(filter: boolean, userId?: string): void {
    this.isActiveFilterType = filter;
    filter
      ? this.notificationsStore.getNotificationsLists({ userId: userId! })
      : this.notificationsStore.filterNotificationByReadUnread(false);
  }

  public markedAll(): void {
    this.notificationsStore.markedNotificationsByReadUnread();
  }

  public markAsViewed(notificationId: string): void {
    this.notificationsStore.readNotification(notificationId);
  }

  public onNotificationClick(link: string, event?: Event) {
    if (event) {
      event.preventDefault();
    }
    this.router.navigate([link]);
  }

  ngOnDestroy(): void {
    if (this.observer) {
      this.observer.disconnect();
    }
    Object.values(this.timers).forEach(timer => clearTimeout(timer));
    Object.keys(this.timers).forEach(id => clearTimeout(this.timers[id]));
  }
}
